// extracted by mini-css-extract-plugin
export default {"container":"ArticleMemberBenefits_container__GGyQM"};